import React from "react";
import Nav from "../../Nav";
import { Container, Typography, Box, Card, CardContent, CardMedia, Button, List, ListItem, ListItemText, Grid } from '@mui/material';
import blog1 from "../images/card2.webp";
import { motion } from 'framer-motion';




const GrammarCard2 = ({ post }) => {

    return (
        <>
            <Nav />
            <Box sx={{ backgroundColor: '#f8fafc', py: 8, fontFamily: 'Arial, sans-serif' }}>
                <Box sx={{ py: 15, textAlign: 'center', color: '#000000' }} style={{ backgroundColor: '#f8fafc' }}>
                    <Container maxWidth="lg" style={{ backgroundColor: '#f8fafc' }}>
                        <Typography variant="h3" align="center" className='merriweather-bold' gutterBottom sx={{ fontWeight: 'bold' }}>
                            Is the verb 'be' interchangeable?
                        </Typography>
                        <div id="image-container" className="absolute top-20 left-0">
                            <img src='https://demo.edublink.co/wp-content/uploads/2023/05/shape-13.png' className="ml-4 mt-4" alt="Small Image" />
                        </div>
                        <div id="image-container2" className="absolute top-20 right-80">
                            <img src='https://demo.edublink.co/wp-content/uploads/2023/07/shape-37.png' className="h-32 w-32" alt='' />
                        </div>
                        <div id="image-container3" className="absolute top-120 right-40">
                            <img src='https://demo.edublink.co/wp-content/uploads/2023/05/shape-02.png' className="h-32 w-32" alt='' />
                        </div>
                        <div id="image-container3" className="absolute bottom-20 right-0">
                            <img src='https://demo.edublink.co/wp-content/themes/edublink/assets/images/shapes/breadcrumb-shape-3.png' className="h-48 w-32" alt='' />
                        </div>
                    </Container>
                </Box>

                <Container maxWidth="lg" sx={{ backgroundColor: '#ffffff', p: 5, borderRadius: 2, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', mt: -8 }}>
                    <Grid container spacing={5} alignItems="flex-start" mb={4}>
                        <Grid item xs={12} lg={6}>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                                In English, the verb 'to be' is incredibly versatile and widely employed.
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                                It fulfills various roles, such as expressing identity ('I am a student'), describing states ('She feels happy'), and creating passive constructions ('The book was authored by John').
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                                It operates across all tenses, serving both as the primary verb and as an auxiliary verb for forming verb phrases.
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', color: '#6b778c' }}>
                                Furthermore, 'to be' is irregular, meaning its conjugations deviate from regular patterns across different tenses. Its adaptability and significance within English grammar allow it to seamlessly fit into diverse contexts and sentence structures.
                            </Typography>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ duration: 0.5, delay: 0.2 }}>
                                <CardMedia
                                    component="img"
                                    image={blog1}
                                    alt="Fresh Start"
                                    sx={{ borderRadius: 2, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)' }}
                                />
                            </motion.div>
                        </Grid>
                    </Grid>
                </Container >
            </Box >
        </>
    );
};

export default GrammarCard2;
